/**
 * @fileOverview Will only render the children if the user is authorized and
 * has an auth token.
 */

import React, { Fragment } from 'react'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ isAuthorized: !!state.token })

const AuthorizedHOC = ({ isAuthorized, children }) => {
  // Returning empty fragments not yet supported
  // https://github.com/facebook/react/pull/12966
  //if (isAuthorized) return <Fragment />
  if (!isAuthorized) return null
  return children
}

export default connect(mapStateToProps)(AuthorizedHOC)


// WEBPACK FOOTER //
// ./src/modules/AuthorizedHOC/AuthorizedHOC.js